import React, { forwardRef } from "react";
import { Space, Image, Upload } from "antd";
import { InputWrapper } from "../InputWrapper/InputWrapper";
import PropTypes from "prop-types";
import Button from "../Button/Button";

const ImageInput = forwardRef(
  (
    {
      label,
      error,
      helperText,
      onChange,
      value,
      handleUpload,
      loading,
      ...props
    },
    ref
  ) => {
    return (
      <InputWrapper label={label} error={error} helperText={helperText}>
        <Space style={{ width: "100%" }}>
          <Upload
            accept="image/*"
            showUploadList={false}
            beforeUpload={handleUpload}
            {...props}
          >
            <Button loading={loading} type="default">
              Upload Image
            </Button>
          </Upload>
          {value && (
            <Image
              src={value}
              alt="Uploaded Image"
              style={{ maxWidth: "100%", maxHeight: "200px" }}
            />
          )}
        </Space>
      </InputWrapper>
    );
  }
);

ImageInput.displayName = "ImageInput";

ImageInput.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default ImageInput;
